/** CoStar.Api.AptsSearch.ViewModels.MatchType */
export var MatchType;
(function (MatchType) {
    MatchType[MatchType["Unknown"] = 0] = "Unknown";
    MatchType[MatchType["Property"] = 1] = "Property";
    MatchType[MatchType["PostalCode"] = 2] = "PostalCode";
    MatchType[MatchType["City"] = 3] = "City";
    MatchType[MatchType["BuildingName"] = 4] = "BuildingName";
    MatchType[MatchType["Submarket"] = 5] = "Submarket";
    MatchType[MatchType["Street"] = 6] = "Street";
    MatchType[MatchType["ResearchMarket"] = 7] = "ResearchMarket";
    MatchType[MatchType["Contact"] = 8] = "Contact";
    MatchType[MatchType["Company"] = 9] = "Company";
    MatchType[MatchType["County"] = 10] = "County";
    MatchType[MatchType["Subdivision"] = 11] = "Subdivision";
    MatchType[MatchType["GeocodeResult"] = 12] = "GeocodeResult";
    MatchType[MatchType["BuildingPark"] = 13] = "BuildingPark";
    MatchType[MatchType["ShoppingCenter"] = 14] = "ShoppingCenter";
    MatchType[MatchType["Country"] = 15] = "Country";
    MatchType[MatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    MatchType[MatchType["Region"] = 17] = "Region";
    MatchType[MatchType["StoreType"] = 18] = "StoreType";
    MatchType[MatchType["CSA"] = 19] = "CSA";
    MatchType[MatchType["PropertyResidential"] = 20] = "PropertyResidential";
    MatchType[MatchType["Cluster"] = 21] = "Cluster";
    MatchType[MatchType["Airport"] = 22] = "Airport";
    MatchType[MatchType["HotelName"] = 23] = "HotelName";
    MatchType[MatchType["TransitStation"] = 24] = "TransitStation";
    MatchType[MatchType["Military"] = 25] = "Military";
    MatchType[MatchType["University"] = 26] = "University";
    MatchType[MatchType["StoreBrand"] = 27] = "StoreBrand";
    MatchType[MatchType["GoogleResults"] = 28] = "GoogleResults";
    MatchType[MatchType["PropertyManagers"] = 29] = "PropertyManagers";
    MatchType[MatchType["SearchEngineOptimization"] = 30] = "SearchEngineOptimization";
    MatchType[MatchType["StreetIntersections"] = 31] = "StreetIntersections";
    MatchType[MatchType["Metro"] = 32] = "Metro";
    MatchType[MatchType["ParkAndRecreation"] = 33] = "ParkAndRecreation";
    MatchType[MatchType["ActiveCompany"] = 34] = "ActiveCompany";
    MatchType[MatchType["TenantLocation"] = 35] = "TenantLocation";
    MatchType[MatchType["TrueOwner"] = 36] = "TrueOwner";
    MatchType[MatchType["SchoolWithAttendanceZone"] = 37] = "SchoolWithAttendanceZone";
    MatchType[MatchType["SchoolWithNoAttendanceZone"] = 38] = "SchoolWithNoAttendanceZone";
    MatchType[MatchType["SchoolDistrict"] = 39] = "SchoolDistrict";
    MatchType[MatchType["CityAggregate"] = 40] = "CityAggregate";
    MatchType[MatchType["MultifamilyProperty"] = 41] = "MultifamilyProperty";
    MatchType[MatchType["PropertyGroup"] = 42] = "PropertyGroup";
    MatchType[MatchType["DMA"] = 43] = "DMA";
    MatchType[MatchType["CoStarMarket"] = 132] = "CoStarMarket";
})(MatchType || (MatchType = {}));
/** CoStar.Api.AptsSearch.ViewModels.CountryBitmap */
export var CountryBitmap;
(function (CountryBitmap) {
    CountryBitmap[CountryBitmap["None"] = 0] = "None";
    CountryBitmap[CountryBitmap["USA"] = 1] = "USA";
    CountryBitmap[CountryBitmap["CAN"] = 2] = "CAN";
})(CountryBitmap || (CountryBitmap = {}));
import { ListingAdLevel } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.ListingAdLevel */
export { ListingAdLevel };
import { ListingPinOptions } from "../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.ListingPinOptions */
export { ListingPinOptions };
/** @deprecated Please use CoStar.Api.AptsSearch.Apartments.Criteria.ListingTypes instead. */
import { ListingType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.ListingType */
export { ListingType };
/** CoStar.Api.AptsSearch.ViewModels.PlacardImageSize */
export var PlacardImageSize;
(function (PlacardImageSize) {
    PlacardImageSize[PlacardImageSize["Unknown"] = 0] = "Unknown";
    PlacardImageSize[PlacardImageSize["Master"] = 1] = "Master";
    /** @deprecated Please use H140W180. */
    PlacardImageSize[PlacardImageSize["Small"] = 4] = "Small";
    /** @deprecated Please use H110W215. */
    PlacardImageSize[PlacardImageSize["Thumbnail"] = 5] = "Thumbnail";
    /** @deprecated Please use H206W337. */
    PlacardImageSize[PlacardImageSize["Edit"] = 6] = "Edit";
    /** @deprecated Please use an alternative value. */
    PlacardImageSize[PlacardImageSize["Enlarge"] = 7] = "Enlarge";
    /** @deprecated Please use H588W984. */
    PlacardImageSize[PlacardImageSize["Large"] = 10] = "Large";
    /** @deprecated Please use H844W1240. */
    PlacardImageSize[PlacardImageSize["ExtraLarge"] = 11] = "ExtraLarge";
    /** @deprecated Please use H900W1800. */
    PlacardImageSize[PlacardImageSize["HighDefinition"] = 12] = "HighDefinition";
    /** @deprecated Please use H720W1400. */
    PlacardImageSize[PlacardImageSize["Widescreen"] = 13] = "Widescreen";
    /** @deprecated Please use H1024W1024. */
    PlacardImageSize[PlacardImageSize["GoLarge"] = 14] = "GoLarge";
    /** @deprecated Please use HVariableW325. */
    PlacardImageSize[PlacardImageSize["GoDetail"] = 15] = "GoDetail";
    /** @deprecated Please use H2048W2048. */
    PlacardImageSize[PlacardImageSize["GoLargeHighDefinition"] = 16] = "GoLargeHighDefinition";
    /** @deprecated Please use HVariableW650. */
    PlacardImageSize[PlacardImageSize["GoDetailHighDefinition"] = 17] = "GoDetailHighDefinition";
    /** @deprecated Please use H220W430. */
    PlacardImageSize[PlacardImageSize["GoThumbnailHighDefinition"] = 18] = "GoThumbnailHighDefinition";
    /** @deprecated Please use HVariableW200. */
    PlacardImageSize[PlacardImageSize["FusionDetailSmall"] = 19] = "FusionDetailSmall";
    PlacardImageSize[PlacardImageSize["H658W984"] = 102] = "H658W984";
    /** @deprecated Please use the non-duplicate version. */
    PlacardImageSize[PlacardImageSize["H658W984Duplicate"] = 103] = "H658W984Duplicate";
    PlacardImageSize[PlacardImageSize["H140W180"] = 104] = "H140W180";
    PlacardImageSize[PlacardImageSize["H110W215"] = 105] = "H110W215";
    /** @deprecated Please use H206W337. */
    PlacardImageSize[PlacardImageSize["H210W315"] = 106] = "H210W315";
    PlacardImageSize[PlacardImageSize["H206W337"] = 106] = "H206W337";
    PlacardImageSize[PlacardImageSize["H588W984"] = 110] = "H588W984";
    PlacardImageSize[PlacardImageSize["H844W1240"] = 111] = "H844W1240";
    PlacardImageSize[PlacardImageSize["H900W1800"] = 112] = "H900W1800";
    PlacardImageSize[PlacardImageSize["H720W1400"] = 113] = "H720W1400";
    PlacardImageSize[PlacardImageSize["H1024W1024"] = 114] = "H1024W1024";
    PlacardImageSize[PlacardImageSize["HVariableW325"] = 115] = "HVariableW325";
    PlacardImageSize[PlacardImageSize["H2048W2048"] = 116] = "H2048W2048";
    PlacardImageSize[PlacardImageSize["HVariableW650"] = 117] = "HVariableW650";
    PlacardImageSize[PlacardImageSize["H220W430"] = 118] = "H220W430";
    PlacardImageSize[PlacardImageSize["HVariableW200"] = 119] = "HVariableW200";
})(PlacardImageSize || (PlacardImageSize = {}));
import { CurrencyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.AptsSearch.ViewModels.CurrencyType */
export { CurrencyType };
/** CoStar.Api.AptsSearch.ViewModels.CountTypes */
export var CountTypes;
(function (CountTypes) {
    CountTypes[CountTypes["None"] = 0] = "None";
    CountTypes[CountTypes["AvailableUnits"] = 1] = "AvailableUnits";
    CountTypes[CountTypes["NewListings"] = 2] = "NewListings";
})(CountTypes || (CountTypes = {}));
/** CoStar.Api.AptsSearch.ViewModels.DefaultSortMode */
export var DefaultSortMode;
(function (DefaultSortMode) {
    DefaultSortMode[DefaultSortMode["Default"] = 0] = "Default";
    DefaultSortMode[DefaultSortMode["MultifamilyAndIndependentOwnerInterleaved"] = 1] = "MultifamilyAndIndependentOwnerInterleaved";
})(DefaultSortMode || (DefaultSortMode = {}));
/** CoStar.Api.AptsSearch.ViewModels.AdRotationType */
export var AdRotationType;
(function (AdRotationType) {
    AdRotationType[AdRotationType["Default"] = 0] = "Default";
    AdRotationType[AdRotationType["ScoreRotation"] = 1] = "ScoreRotation";
    AdRotationType[AdRotationType["AdLevelAndScoreRotation"] = 2] = "AdLevelAndScoreRotation";
})(AdRotationType || (AdRotationType = {}));
import { AreaMeasure } from "../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.AptsSearch.ViewModels.AreaMeasure */
export { AreaMeasure };
import { AvailabilityStatus } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.AvailabilityStatus */
export { AvailabilityStatus };
import { ListingPhoneType } from "../../../../CoStar/Api/AptsListings/ResidentialForRent/index.js";
/** CoStar.Api.AptsSearch.ViewModels.ListingPhoneType */
export { ListingPhoneType };
/** CoStar.Api.AptsSearch.ViewModels.GeographyType */
export var GeographyType;
(function (GeographyType) {
    GeographyType[GeographyType["Unknown"] = 0] = "Unknown";
    GeographyType[GeographyType["Property"] = 1] = "Property";
    GeographyType[GeographyType["PostalCode"] = 2] = "PostalCode";
    GeographyType[GeographyType["City"] = 3] = "City";
    GeographyType[GeographyType["BuildingName"] = 4] = "BuildingName";
    GeographyType[GeographyType["Submarket"] = 5] = "Submarket";
    GeographyType[GeographyType["Street"] = 6] = "Street";
    GeographyType[GeographyType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyType[GeographyType["Contact"] = 8] = "Contact";
    GeographyType[GeographyType["Company"] = 9] = "Company";
    GeographyType[GeographyType["County"] = 10] = "County";
    GeographyType[GeographyType["Subdivision"] = 11] = "Subdivision";
    GeographyType[GeographyType["GeocodeResult"] = 12] = "GeocodeResult";
    GeographyType[GeographyType["BuildingPark"] = 13] = "BuildingPark";
    GeographyType[GeographyType["ShoppingCenter"] = 14] = "ShoppingCenter";
    GeographyType[GeographyType["Country"] = 15] = "Country";
    GeographyType[GeographyType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyType[GeographyType["Region"] = 17] = "Region";
    GeographyType[GeographyType["StoreType"] = 18] = "StoreType";
    GeographyType[GeographyType["TransitStation"] = 19] = "TransitStation";
    GeographyType[GeographyType["PropertyResidential"] = 20] = "PropertyResidential";
    GeographyType[GeographyType["Cluster"] = 21] = "Cluster";
    GeographyType[GeographyType["Airport"] = 22] = "Airport";
    GeographyType[GeographyType["HotelName"] = 23] = "HotelName";
    GeographyType[GeographyType["Military"] = 25] = "Military";
    GeographyType[GeographyType["University"] = 26] = "University";
    GeographyType[GeographyType["StoreBrand"] = 27] = "StoreBrand";
    GeographyType[GeographyType["GoogleResults"] = 28] = "GoogleResults";
    GeographyType[GeographyType["PropertyManagers"] = 29] = "PropertyManagers";
    GeographyType[GeographyType["SearchEngineOptimization"] = 30] = "SearchEngineOptimization";
    GeographyType[GeographyType["StreetIntersections"] = 31] = "StreetIntersections";
    GeographyType[GeographyType["Metro"] = 32] = "Metro";
    GeographyType[GeographyType["ParkAndRecreation"] = 33] = "ParkAndRecreation";
    GeographyType[GeographyType["SchoolWithAttendanceZone"] = 37] = "SchoolWithAttendanceZone";
    GeographyType[GeographyType["SchoolWithNoAttendanceZone"] = 38] = "SchoolWithNoAttendanceZone";
    GeographyType[GeographyType["SchoolDistrict"] = 39] = "SchoolDistrict";
    GeographyType[GeographyType["CityAggregate"] = 40] = "CityAggregate";
    GeographyType[GeographyType["MultifamilyProperty"] = 41] = "MultifamilyProperty";
})(GeographyType || (GeographyType = {}));
import { ProsumerLevel } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.ProsumerLevel */
export { ProsumerLevel };
/** CoStar.Api.AptsSearch.ViewModels.ListingPlacardOptions */
export var ListingPlacardOptions;
(function (ListingPlacardOptions) {
    ListingPlacardOptions[ListingPlacardOptions["None"] = 0] = "None";
    ListingPlacardOptions[ListingPlacardOptions["IsTier2"] = 1] = "IsTier2";
    ListingPlacardOptions[ListingPlacardOptions["IsNew"] = 2] = "IsNew";
})(ListingPlacardOptions || (ListingPlacardOptions = {}));
import { RentPricingTypes } from "../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.RentPricingTypes */
export { RentPricingTypes };
import { ApartmentStyleType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.ApartmentStyleType */
export { ApartmentStyleType };
/** CoStar.Api.AptsSearch.ViewModels.PropertyTypeCriteria */
export var PropertyTypeCriteria;
(function (PropertyTypeCriteria) {
    PropertyTypeCriteria[PropertyTypeCriteria["None"] = 0] = "None";
    PropertyTypeCriteria[PropertyTypeCriteria["Detached"] = 1] = "Detached";
    PropertyTypeCriteria[PropertyTypeCriteria["Townhouse"] = 2] = "Townhouse";
    PropertyTypeCriteria[PropertyTypeCriteria["Condo"] = 4] = "Condo";
    PropertyTypeCriteria[PropertyTypeCriteria["Other"] = 8] = "Other";
    PropertyTypeCriteria[PropertyTypeCriteria["MultiFamily"] = 16] = "MultiFamily";
    PropertyTypeCriteria[PropertyTypeCriteria["LotsLands"] = 32] = "LotsLands";
    PropertyTypeCriteria[PropertyTypeCriteria["MobileManufactured"] = 64] = "MobileManufactured";
    PropertyTypeCriteria[PropertyTypeCriteria["Commercial"] = 128] = "Commercial";
    PropertyTypeCriteria[PropertyTypeCriteria["Coop"] = 256] = "Coop";
    PropertyTypeCriteria[PropertyTypeCriteria["Unknown1"] = 512] = "Unknown1";
})(PropertyTypeCriteria || (PropertyTypeCriteria = {}));
import { AvailabilityMatchType } from "../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.AvailabilityMatchType */
export { AvailabilityMatchType };
import { RentPricingType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.ViewModels.RentPricingType */
export { RentPricingType };
